<div class="container">
  <nav class="navbar navbar-expand-lg navbar-light bg-light my-3">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#mailNav" aria-controls="mailNav"
      aria-expanded="false" aria-label="mailNav navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse p-justify-end align-items-end" id="mailNav">
      <form class="form-inline my-2 my-lg-0">
        <button class="btn btn-outline-secondary btn-sm mr-2 my-sm-0" (click)="onSend()" [disabled]="replyForm.invalid" type="button">Send</button>
        <button class="btn btn-outline-secondary btn-sm mr-2 my-sm-0" (click)="onSave()" [disabled]="replyForm.invalid" type="button">Save to
          Draft</button>
        <button  class="btn btn-outline-secondary btn-sm mr-2 my-sm-0" (click)="onCancel()" type="button">Cancel</button>
        <!-- <button *ngIf="isUnified" class="btn btn-outline-secondary btn-sm mr-2 my-sm-0" (click)="close()" type="button">Close</button> -->

        
      </form>
    </div>
  </nav>
  <mat-divider></mat-divider>
  <form [formGroup]="replyForm">

    <div class="row">
      <div class="col-2 p-0 float-left">
        <p class="label-cls mb-2 mt-3">Template Name</p>
        <p-dropdown inputId="" [options]="templateList" placeholder="Template List" optionLabel="templateName" optionValue="id"
          name="templateName" (onChange)="onSelectEmailTemplate($event)" formControlName="templateName">
        </p-dropdown>
      </div>
      <div class="col-3 float-left">
        <div class="mt-5"><a class="link" (click)="navigate()">Create New Template</a></div>
      </div>
    </div>
    <div class="row">
      <div class="col-2 ml-0 pl-0">
        <p class="label-cls mb-2 mt-3">Priority</p>
        <p-dropdown inputId="" [options]="priorityList" placeholder="Priority" optionLabel="name" optionValue="code"
          name="priority" formControlName="priority">
        </p-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 p-0">
        <p class="label-cls required mb-2 mt-3">To</p>
        <!-- <input class="input-align" type="text" name="to" formControlName="to" /> -->
        <p-chips class="w-100" formControlName="to" separator="," [allowDuplicate]="false" (onAdd)="validateEmailAddress($event,'to')"
                required ></p-chips>
        <!-- 
          (onAdd)="validateEmailAddress($event, 'to')"-->
          <small *ngIf="(replyForm.get('to').touched || submitted) && replyForm.get('to').errors" class="p-error">
          <span *ngIf="replyForm.get('to').errors['required']">To is required.</span>
          <span *ngIf="replyForm.get('to').hasError('pattern') && !replyForm.get('to').errors['duplicateEmail']">To
            email(s) Invalid.</span>
          <span *ngIf="replyForm.get('to').errors['duplicateEmail']">Duplicate email match in cc. </span>
        </small> 
      </div>
      <!-- <div class="col-12 p-0">
        <p class="label-cls mb-2 mt-3">CC</p>
        <input class="input-align" type="text" name="cc" formControlName="cc" />
        <small *ngIf="(replyForm.get('cc').touched || submitted) && replyForm.get('cc').errors" class="p-error">
          <span *ngIf="replyForm.get('cc').hasError('pattern') && !replyForm.get('cc').errors['duplicateEmail']">CC
            email(s) Invalid.</span>
          <span *ngIf="replyForm.get('cc').errors['duplicateEmail']">Duplicate email match in To. </span>
        </small>
      </div> -->
      <div class="col-md-12 p-0">
        <p class="label-cls mb-2 mt-3">CC</p>
        <p-chips class="w-100" formControlName="cc" separator="," [allowDuplicate]="false" (onAdd)="validateEmailAddress($event,'cc')"></p-chips>
        <small *ngIf="(replyForm.get('cc').touched || submitted) && replyForm.get('cc').errors" class="p-error">
          <span *ngIf="replyForm.get('cc').hasError('pattern') && !replyForm.get('cc').errors['duplicateEmail']">CC
            email(s) Invalid.</span>
          <span *ngIf="replyForm.get('cc').errors['duplicateEmail']">Duplicate email match in To. </span>
        </small>
      </div>
      <div class="col-12 p-0">
        <p class="label-cls required mb-2 mt-3">Subject</p>
        <input class="" type="text" name="subject" formControlName="subject" />
        <small *ngIf="(replyForm.get('subject').touched || submitted) && replyForm.get('subject').errors"
          class="p-error">
          <span *ngIf="replyForm.get('subject').errors['required']">Subject is required.</span>
        </small>
      </div>
    </div>
    <div class="d-flex flex-column mt-2">
      <div class="d-flex align-items-center">
        <p-fileUpload #createUploader name="demo[]" mode="basic" chooseLabel="Upload" [auto]="true" customUpload="true"
          (uploadHandler)="Upload($event, createUploader)" accept="{{acceptedFiles}}" multiple="multiple"
          showUploadButton="false" showCancelButton="true" maxFileSize="10485760">
        </p-fileUpload>
        <p class="label-cls ml-2 mb-2 mt-3"><span><i class="pi pi-exclamation-circle"
              pTooltip="Allowed File Types: {{acceptedFiles}}" tooltipPosition="top"></i></span></p>
      </div>
      <div class="colp-0">
        <ul *ngIf="(uploadedFiles$ | async)?.length" class="list-group list-group-horizontal mt-1 flex-wrap">
          <li *ngFor="let file of (uploadedFiles$ | async); let i=index" class="list-group-item">{{file.name}} - <span
              id="deleteCls" (click)="deleteFile(i)">X</span></li>
        </ul>
      </div>
    </div>
    <div class="row mt-3">
      <div class="customInputContainer">
        <kendo-editor #commonkendoeditor style="height: 500px;" name="editor" formControlName="editor">
          <!-- <kendo-editor [(value)]="previewLetter" (valueChange)="previewLettereditorValueChange($event)" #letterpreviewkendoeditor style="height: 400px;" name="coverLetterTextContent">     -->
          <kendo-toolbar>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorSubscriptButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorSuperscriptButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
            <kendo-toolbar-dropdownlist kendoEditorFontFamily></kendo-toolbar-dropdownlist>
            <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
            <kendo-toolbar-colorpicker kendoEditorBackColor view="gradient"></kendo-toolbar-colorpicker>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorBlockquoteButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorSelectAllButton></kendo-toolbar-button>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorUndoButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorRedoButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorCreateLinkButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorUnlinkButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorInsertFileButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorViewSourceButton></kendo-toolbar-button>
            <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
            <kendo-editor-insert-table-button></kendo-editor-insert-table-button>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorAddColumnBeforeButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAddColumnAfterButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAddRowBeforeButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorAddRowAfterButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorDeleteColumnButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorDeleteRowButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorDeleteTableButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorMergeCellsButton></kendo-toolbar-button>
              <kendo-toolbar-button kendoEditorSplitCellButton></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
            <kendo-toolbar-button kendoEditorPrintButton></kendo-toolbar-button>
            <kendo-toolbar-buttongroup>
              <kendo-toolbar-button kendoEditorInsertImageButton></kendo-toolbar-button>
              <kendo-toolbar-button title="Upload’s Image at cursor point" text="Upload Image"
                (click)="commonkendoeditorimageuploaddialog()"></kendo-toolbar-button>
            </kendo-toolbar-buttongroup>
          </kendo-toolbar>
        </kendo-editor>
        <app-upload-image-dialog #commonkendoeditorupload [editor]="commonkendoeditor"></app-upload-image-dialog>
      </div>
    </div>
  </form>
</div>
<p-dialog header="Discard" [(visible)]="discardDialog" [modal]="true" [style]="{ width: '25vw' }" [draggable]="false"
  [resizable]="false">
  <div class="divider"></div>
  <div class="row mt-2">
    <p>If you don't want a message to send you can permenantly delete it.</p>
  </div>
  <div class="divider mt-3 mb-3"></div>
  <div class="row d-flex">
    <p-button label="Delete" icon="pi pi-trash" iconPos="left" (click)="discard()"></p-button>
  </div>
</p-dialog>